import React, { useEffect, useState } from "react";
import { useI18n } from "@/contexts/I18nContext";
import { api, getMl } from "@/lib/api";
import * as LucideIcons from "lucide-react";

const TradeServices = () => {
  const { t, lang } = useI18n();
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  return (
    <div data-testid="services-page">
      <section className="bg-[#0A1128] text-white py-24 md:py-28 relative">
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: "linear-gradient(180deg, rgba(10,17,40,0.95) 0%, rgba(10,17,40,0.7) 100%), url('https://images.unsplash.com/photo-1761682751206-f33ad944be5d')",
          backgroundSize: "cover", backgroundPosition: "center",
        }} />
        <div className="container-nakia relative">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-divider" />
            <span className="text-eyebrow text-[#D4AF37]">Services</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.05]">{t("nav.services")}</h1>
          <p className="text-white/80 max-w-2xl mt-6 text-lg">{t("sections.servicesSub")}</p>
        </div>
      </section>

      <section className="py-24 sm:py-32 bg-white">
        <div className="container-nakia">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s) => {
              const Icon = LucideIcons[s.icon] || LucideIcons.Sparkles;
              return (
                <div key={s.id} data-testid={`service-${s.id}`} className="card-light p-8">
                  <div className="w-12 h-12 border border-[#D4AF37]/40 flex items-center justify-center rounded-sm mb-5">
                    <Icon size={20} className="text-[#D4AF37]" />
                  </div>
                  <h3 className="font-display text-xl text-[#0A1128] mb-3">{getMl(s.name, lang)}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{getMl(s.description, lang)}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TradeServices;
